// color-schemes.js

document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('section');
  const bodyContainer = document.querySelector('body');
  const mainContainer = document.querySelector('#main');
  const header = document.querySelector('x-header');
  const logoPaths = document.querySelectorAll('svg *');

  function setTextColorForAllSections(scheme) {
    // Update the --text-color for all sections based on the active scheme, excluding the footer
    const textColor = scheme === 'dark' ? 'var(--dark-text-color)' : 'var(--light-text-color)';
    
    document.querySelectorAll('.color-scheme--dark, .color-scheme--light').forEach((section) => {
      if (!section.classList.contains('footer') && section.id !== 'sidebar-menu') { // Skip the footer and sidebar-menu
        section.style.setProperty('--text-color', textColor);
      }
    });    
  }

  function updateBackground() {
    let closestSection = sections[0];
    let closestDistance = Infinity;

    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      
      // Check if the section is within the viewport (partially or fully)
      const isInView = (rect.top < window.innerHeight && rect.bottom > 0);
      
      if (isInView) {
        const distanceFromViewportTop = Math.abs(rect.top);

        // Find the section closest to the top of the viewport
        if (distanceFromViewportTop < closestDistance) {
          closestDistance = distanceFromViewportTop;
          closestSection = section;
        }
      }
    });

    const colorSchemeDiv = closestSection.querySelector('.color-scheme');
    if (colorSchemeDiv) {
      // Detect the current color scheme and apply the same one to the header
      const isDarkScheme = colorSchemeDiv.classList.contains('color-scheme--dark');
      const currentScheme = isDarkScheme ? 'dark' : 'light';

      // Log the active scheme
      // console.log(`Active color scheme: ${currentScheme}`);

      // Apply the same scheme to the header
      header.classList.remove('color-scheme--light', 'color-scheme--dark');
      header.classList.add(`color-scheme--${currentScheme}`);

      const backgroundColor = getComputedStyle(colorSchemeDiv).getPropertyValue('--background');
      mainContainer.style.backgroundColor = `rgb(${backgroundColor})`;
      bodyContainer.style.backgroundColor = `rgb(${backgroundColor})`;

      // Set logo fill color based on the color scheme
      const fillColor = isDarkScheme ? '#ffffff' : '#000000';

      logoPaths.forEach((path) => {
        path.setAttribute('fill', fillColor);
      });

      // Set text color for both .color-scheme--dark and .color-scheme--light
      setTextColorForAllSections(currentScheme);
    }
  }

  // Set initial text colors for all sections on page load
  updateBackground();
  
  // Update background, logo fill, and text color when scrolling
  window.addEventListener('scroll', updateBackground);
});
